import React from "react";

const badges = [
  "100% AYURVEDIC",
  "NO STEROIDS",
  "NO CHEMICALS",
  "MADE IN INDIA",
  "GMP CERTIFIED",
  "SAFE PAYMENTS",
  "COD AVAILABLE",
  "FSSAI APPROVED",
];

export default function TrustMarquee() {
  const doubled = [...badges, ...badges];
  return (
    <div className="relative overflow-hidden border-y border-white/5 bg-black py-3">
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
        {doubled.map((b, i) => (
          <span
            key={i}
            className="font-display text-lg tracking-widest text-neutral-400"
          >
            <span className="mr-10 text-[#FF7A00]">★</span>
            {b}
          </span>
        ))}
      </div>
    </div>
  );
}
